import React from 'react'
const RegisterUser = () => {
    return ( 
        <h2>
            Register User
        </h2>
     );
}
 
export default RegisterUser;